// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__3XtHx","active":"Breadcrumbs_active__37yRc"};